<template>
  <div v-if="tapRequestId" class="row">
    <div class="col-12 mb-1">
      <SectionTitle
        :has-line="true"
        :title="'Servicios provistos por el programa de educación especial'"
      />
    </div>

    <div v-show="hasAnyItems || activeForms" class="col-12 mb-3">
      <RelatedServiceFormWrapper
        :tap-request-id="tapRequestId"
        :submitted="submitted"
        :canEdit="canEditRelatedService"
        :items="items.related"
        :statusId="statusId"
      />
    </div>

    <div v-show="hasAnyItems || activeForms" class="col-12">
      <SupplementaryServiceFormWrapper
        :tap-request-id="tapRequestId"
        :submitted="submitted"
        :items="items.supplementary"
      />
    </div>

    <div class="col-12">
      <template v-if="submitted">
        <div
          v-if="!hasAnyItems"
          class="bg-light-gray border-radius--light py-4 text-center"
        >
          No posee servicios provistos
        </div>
      </template>
      <template v-else>
        <ActivationButton
          v-if="!(hasAnyItems || activeForms)"
          text="Presione aquí para añadir servicios provistos"
          @click.stop="activeForms = true"
        />
      </template>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import RelatedServiceFormWrapper from './_components/RelatedServiceFormWrapper';
import SupplementaryServiceFormWrapper from './_components/SupplementaryServiceFormWrapper';
import { ActivationButton } from '@/components/common';
import { isTapRelatedFilter, isTapSupplementaryFilter } from './_utils';
import { servicesProvidedApi } from './_api';
import { tapRequestStatusesEnum } from '@/components/pei/ubication-tech-assistance/_types';

export default {
  name: 'ServicesProvided',
  components: {
    SectionTitle,
    RelatedServiceFormWrapper,
    SupplementaryServiceFormWrapper,
    ActivationButton,
  },
  props: {
    tapRequestId: { type: Number, required: true, default: null },
    submitted: { type: Boolean, default: false },
  },
  data: () => ({
    items: { related: [], supplementary: [] },
    activeForms: false,
    statusId: null,
  }),
  computed: {
    hasAnyItems() {
      return !!Object.values(this.items).flatMap((x) => x).length;
    },
    canEditRelatedService() {
      let canEdit = !this.submitted;

      const hasEditPermission = this.$store.getters.HasPermission(
        'academic.pei.ubicationtechassistance.edit.relatedservices.onprocessamendment'
      );
      if (
        this.statusId === tapRequestStatusesEnum['Proceso de Enmienda'] &&
        hasEditPermission
      ) {
        canEdit = true;
      }

      return canEdit;
    },
  },
  methods: {
    async getAll() {
      const result = await servicesProvidedApi.getAll(this.tapRequestId);

      if (result?.length > 0 ?? false) {
        this.items = {
          related: result.filter(isTapRelatedFilter),
          supplementary: result.filter(isTapSupplementaryFilter),
        };
      }
    },
    async getStatus() {
      const statusId = await servicesProvidedApi.getTapRequestStatus(
        this.tapRequestId
      );
      this.statusId = statusId;
    },
  },
  watch: {
    items: {
      handler() {
        this.$emit('input', this.hasAnyItems);
      },
      deep: true,
    },
  },
  async created() {
    await Promise.all([this.getAll(), this.getStatus()]);
  },
};
</script>
